var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDvStep3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20703 13.1309H43.7939C44.8018 13.1309 45.624 13.9531 45.624 14.9609V42.8643C45.624 43.8721 44.8018 44.6943 43.7939 44.6943H6.20703C5.19922 44.6943 4.37695 43.8721 4.37695 42.8643V14.9609C4.37695 13.9531 5.19922 13.1309 6.20703 13.1309Z",
    fill: "#2F5274"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.628906 42.042H49.3711C49.7168 42.042 49.999 42.3242 49.999 42.6699V44.9951C49.999 46.623 48.6699 47.9512 47.0449 47.9512H2.95703C1.3291 47.9521 0 46.624 0 44.9961V42.6709C0 42.3252 0.282227 42.042 0.628906 42.042Z",
    fill: "#53718E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8418 16.8633H41.1582C41.8281 16.8633 42.3789 17.4111 42.3789 18.084V36.6914C42.3789 37.3643 41.8281 37.9121 41.1582 37.9121H8.8418C8.17188 37.9121 7.62402 37.3643 7.62402 36.6914V18.084C7.62402 17.4111 8.17188 16.8633 8.8418 16.8633Z",
    fill: "#EBF5FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8418 16.8633H10.2617V37.9131H8.8418C8.17188 37.9131 7.62402 37.3652 7.62402 36.6924V18.084C7.62402 17.4111 8.17188 16.8633 8.8418 16.8633Z",
    fill: "#D4DDE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6279 42.042H35.373V43.1641C35.373 43.7812 34.8662 44.2852 34.252 44.2852H15.751C15.1338 44.2852 14.627 43.7812 14.627 43.1641V42.042H14.6279Z",
    fill: "#223C55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.628906 42.042H2.79687C2.45117 42.042 2.16895 42.3242 2.16895 42.6699V44.9951C2.16895 46.623 3.49805 47.9512 5.12305 47.9512H2.95703C1.3291 47.9521 0 46.624 0 44.9961V42.6709C0 42.3252 0.282227 42.042 0.628906 42.042Z",
    fill: "#4B6680"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4873 10.5596C11.3809 20.0908 15.3057 29.4746 25 33.165C34.6973 29.4746 38.6191 20.0908 40.5127 10.5596C36.5703 9.26367 33.4922 6.06445 32.3682 2.04688H17.6309C16.5068 6.06445 13.4287 9.26367 9.4873 10.5596Z",
    fill: "#0593FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 29.7568C31.9648 26.5508 35.165 19.5645 36.8926 12.4004C33.9502 10.7842 31.5889 8.25098 30.1855 5.18945H19.8154C18.4121 8.25098 16.0508 10.7842 13.1084 12.4004C14.835 19.5645 18.0381 26.5518 25 29.7568Z",
    fill: "#EBF5FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 29.7568C27.9258 28.4092 30.1875 26.3965 31.9541 23.9824V22.8477C31.9541 19.7607 29.4268 17.2334 26.3398 17.2334H23.6602C20.5732 17.2334 18.0459 19.7607 18.0459 22.8477V23.9824C19.8125 26.3965 22.0742 28.4092 25 29.7568Z",
    fill: "#FFD400"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.918 28.0488C28.4883 27.6338 29.0254 27.1904 29.5322 26.7197V24.0762C29.5322 23.6309 29.1719 23.2705 28.7266 23.2705C28.2812 23.2705 27.918 23.6309 27.918 24.0762V28.0488ZM20.4688 26.7207C20.9756 27.1914 21.5127 27.6338 22.083 28.0498V24.0771C22.083 23.6318 21.7207 23.2715 21.2744 23.2715C20.8311 23.2715 20.4688 23.6318 20.4688 24.0771V26.7207Z",
    fill: "#BA9B00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0371 21.9951C43.8984 21.9951 47.0488 18.8477 47.0488 14.9834C47.0488 11.1221 43.8984 7.97168 40.0371 7.97168C36.1758 7.97168 33.0254 11.1221 33.0254 14.9834C33.0254 18.8477 36.1748 21.9951 40.0371 21.9951Z",
    fill: "#70DA40"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 18.9443C27.4023 18.9443 29.3623 16.8047 29.3623 14.1826C29.3623 11.5586 27.4023 9.41895 25 9.41895C22.5977 9.41895 20.6396 11.5586 20.6396 14.1826C20.6396 16.8047 22.5977 18.9443 25 18.9443Z",
    fill: "#FBBD80"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6111 12.5618C42.9265 12.2463 43.4363 12.2463 43.7517 12.5618C44.0671 12.8772 44.0671 13.387 43.7517 13.7024L40.0447 17.4094C39.7292 17.7249 39.2195 17.7249 38.9041 17.4094L36.321 14.8235C36.0056 14.5081 36.0056 13.9983 36.321 13.6829C36.6335 13.3674 37.1462 13.3674 37.4587 13.6829L39.4744 15.6985L42.6111 12.5618Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4629 7.98535C40.3213 7.97754 40.1807 7.97168 40.0361 7.97168C38.9209 7.97168 37.8682 8.23145 36.9326 8.69434C35.9551 9.17871 35.1055 9.88184 34.4521 10.7432C33.915 11.4463 33.5107 12.2549 33.2705 13.1318C33.1104 13.7217 33.0244 14.3447 33.0244 14.9834C33.0244 15.6338 33.1133 16.2646 33.2793 16.8633C33.5371 17.7988 33.9854 18.6572 34.5801 19.3906C35.2607 20.2324 36.1299 20.9102 37.124 21.3672C38.0127 21.7715 38.998 21.9951 40.0361 21.9951C40.1797 21.9951 40.3213 21.9922 40.4629 21.9844C36.7842 21.7686 33.8691 18.7178 33.8691 14.9834C33.8691 11.252 36.7842 8.20117 40.4629 7.98535Z",
    fill: "#65C43A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0029 29.7568C23.9287 29.001 22.96 28.1455 22.082 27.2129V28.0488C22.9736 28.6963 23.9424 29.2695 25 29.7568H25.0029Z",
    fill: "#E6BF00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.082 28.0488V27.2129C21.5059 26.6035 20.9688 25.959 20.4678 25.2832V26.7197C20.9746 27.1914 21.5117 27.6338 22.082 28.0488Z",
    fill: "#A78C00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4688 26.7207V25.2842C19.6104 24.127 18.8545 22.8838 18.1934 21.583C18.0967 21.9902 18.0469 22.4131 18.0469 22.8477V23.9824C18.7686 24.9678 19.5713 25.8867 20.4688 26.7207Z",
    fill: "#E6BF00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0459 22.8477C18.0459 22.4131 18.0957 21.9893 18.1924 21.583C17.4258 20.0771 16.7773 18.4912 16.2246 16.8633C15.8096 15.6367 15.4463 14.3887 15.1279 13.1318C15.0723 12.916 15.0195 12.6973 14.9678 12.4814C17.9961 10.8174 20.46 8.27148 22.0186 5.19043H19.8154C18.4121 8.25195 16.0508 10.7852 13.1084 12.4014C13.167 12.6445 13.2275 12.8887 13.291 13.1318C13.6123 14.3916 13.9834 15.6426 14.415 16.8633C15.3203 19.4238 16.4912 21.8604 18.0469 23.9834V22.8477H18.0459Z",
    fill: "#D4DDE3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7695 13.1309C22.1709 11.1816 23.666 9.6875 25.5117 9.45215C25.3428 9.42969 25.1738 9.41895 25 9.41895C22.9209 9.41895 21.1826 11.0049 20.7451 13.1309C20.6758 13.4688 20.6396 13.8203 20.6396 14.1826C20.6396 15.1768 20.916 16.0986 21.3955 16.8623C21.542 17.0977 21.708 17.3193 21.8906 17.5215C22.6826 18.3994 23.7812 18.9443 24.999 18.9443C25.1738 18.9443 25.3428 18.9336 25.5107 18.9111C24.4063 18.7695 23.4287 18.1807 22.7344 17.3115C22.6211 17.168 22.5156 17.0186 22.4189 16.8633C21.9404 16.0996 21.6602 15.1777 21.6602 14.1836C21.6611 13.8203 21.7002 13.4688 21.7695 13.1309Z",
    fill: "#E2AA73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvStep3Icon);
export default __webpack_public_path__ + "static/media/dv_step3_icon.3d99d21aa3bbcd7c8ffb335eae6d8221.svg";
export { ForwardRef as ReactComponent };